import React from 'react'
import { Alert, Button } from 'antd'
import { WarningOutlined } from '@ant-design/icons'

const DeprecationBanner: React.FC = () => {
  const isProduction = process.env.REACT_APP_VIXEN_API_URL === 'https://api.a4b.io'
  const redirectUrl = isProduction ? 'https://setu.a4b.io' : 'https://setu-sbox.a4b.io'

  const handleRedirect = () => {
    window.open(redirectUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Alert
      message={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '8px 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <WarningOutlined style={{ fontSize: '24px', color: '#ff4d4f' }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#ff4d4f', marginBottom: '8px' }}>
                CRITICAL NOTICE: THIS CMS WILL BE DEPRECATED SOON
              </div>
              <div style={{ fontSize: '14px', lineHeight: '1.8' }}>
                <div style={{ marginBottom: '4px' }}>
                  <strong style={{ color: '#d32029' }}>• This platform is no longer supported</strong>
                </div>
                <div style={{ marginBottom: '4px' }}>
                  <strong style={{ color: '#d32029' }}>• No new changes will be accepted</strong>
                </div>
                <div>
                  <strong style={{ color: '#d32029' }}>• All operations must be performed on the new SETU platform</strong>
                </div>
              </div>
            </div>
            <Button 
              type="primary" 
              danger 
              onClick={handleRedirect} 
              size="large"
              style={{ fontWeight: 'bold', minWidth: '180px' }}
            >
              Go to New Platform →
            </Button>
          </div>
          <div style={{ fontSize: '14px', color: '#595959', paddingLeft: '36px' }}>
            For any questions or assistance, please contact:{' '}
            <a href="mailto:santosh@appsforbharat.com" style={{ fontWeight: 'bold' }}>santosh@appsforbharat.com</a>
            {' '}or{' '}
            <a href="mailto:nitin@appsforbharat.com" style={{ fontWeight: 'bold' }}>nitin@appsforbharat.com</a>
          </div>
        </div>
      }
      type="error"
      showIcon={false}
      closable={false}
      style={{ 
        marginBottom: '20px',
        border: '3px solid #ff4d4f',
        backgroundColor: '#fff2f0'
      }}
      className="deprecation-banner-no-close"
    />
  )
}

export default DeprecationBanner
